<template>
  <div>
    <Header></Header>
    <race-table class="mt60"></race-table>
  </div>
</template>

<script>
import Header from "@/components/dashboard/Header";
import RaceTable from "@/components/RaceTable";
import RaceForm from "@/components/RaceForm";

export default {
  data() {
    return {
      Racers: []
    };
  },
  components: {
    Header,
    RaceTable,
    RaceForm
  }
};
</script>

<style scoped>
.mt60 {
  margin-top: 60px !important;
}
</style>
